/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LocationsService {
    /**
     * Create a new location
     * @param requestBody
     * @returns any Location created successfully
     * @throws ApiError
     */
    public static postApiV2Locations(
        requestBody: {
            /**
             * Corporate entity ID (optional)
             */
            cid?: number;
            /**
             * Business function (optional)
             */
            businessfunction?: string;
            /**
             * Manager user ID
             */
            managerid: number;
            /**
             * Two-letter country code in uppercase
             */
            country_code: string;
            /**
             * Street address
             */
            address: string;
            /**
             * City name
             */
            city: string;
            /**
             * State or province (optional)
             */
            state?: string;
            /**
             * Postal or ZIP code (optional)
             */
            postal_code?: string;
            /**
             * GPS coordinates (optional)
             */
            gpscoordinates?: string;
        },
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: {
            /**
             * Location ID
             */
            id?: number;
            /**
             * Corporate entity ID
             */
            cid?: number | null;
            /**
             * Business function
             */
            businessfunction?: string | null;
            /**
             * Manager user ID
             */
            managerid?: number;
            /**
             * Two-letter country code
             */
            country_code?: string;
            /**
             * Street address
             */
            address?: string;
            /**
             * City name
             */
            city?: string;
            /**
             * State or province
             */
            state?: string | null;
            /**
             * Postal or ZIP code
             */
            postal_code?: string | null;
            /**
             * GPS coordinates
             */
            gpscoordinates?: string | null;
            /**
             * Creation timestamp
             */
            created?: string | null;
            /**
             * Last update timestamp
             */
            updated?: string | null;
        };
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v2/locations',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update a location
     * @param id
     * @param requestBody
     * @returns any Location updated successfully
     * @throws ApiError
     */
    public static putApiV2Locations(
        id: number,
        requestBody: {
            /**
             * Corporate entity ID (optional)
             */
            cid?: number;
            /**
             * Business function (optional)
             */
            businessfunction?: string;
            /**
             * Manager user ID (optional)
             */
            managerid?: number;
            /**
             * Two-letter country code in uppercase (optional)
             */
            country_code?: string;
            /**
             * Street address (optional)
             */
            address?: string;
            /**
             * City name (optional)
             */
            city?: string;
            /**
             * State or province (optional)
             */
            state?: string;
            /**
             * Postal or ZIP code (optional)
             */
            postal_code?: string;
            /**
             * GPS coordinates (optional)
             */
            gpscoordinates?: string;
        },
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: {
            /**
             * Location ID
             */
            id?: number;
            /**
             * Corporate entity ID
             */
            cid?: number | null;
            /**
             * Business function
             */
            businessfunction?: string | null;
            /**
             * Manager user ID
             */
            managerid?: number;
            /**
             * Two-letter country code
             */
            country_code?: string;
            /**
             * Street address
             */
            address?: string;
            /**
             * City name
             */
            city?: string;
            /**
             * State or province
             */
            state?: string | null;
            /**
             * Postal or ZIP code
             */
            postal_code?: string | null;
            /**
             * GPS coordinates
             */
            gpscoordinates?: string | null;
            /**
             * Creation timestamp
             */
            created?: string | null;
            /**
             * Last update timestamp
             */
            updated?: string | null;
        };
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v2/locations/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a location
     * @param id
     * @returns any Location deleted successfully
     * @throws ApiError
     */
    public static deleteApiV2Locations(
        id: number,
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v2/locations/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update a location's address
     * @param id
     * @param requestBody
     * @returns any Location address updated successfully
     * @throws ApiError
     */
    public static patchApiV2LocationsAddress(
        id: number,
        requestBody: {
            /**
             * Two-letter country code in uppercase (optional)
             */
            country_code?: string;
            /**
             * Street address (optional)
             */
            address?: string;
            /**
             * City name (optional)
             */
            city?: string;
            /**
             * State or province (optional)
             */
            state?: string;
            /**
             * Postal or ZIP code (optional)
             */
            postal_code?: string;
            /**
             * GPS coordinates (optional)
             */
            gpscoordinates?: string;
        },
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: {
            /**
             * Location ID
             */
            id?: number;
            /**
             * Corporate entity ID
             */
            cid?: number | null;
            /**
             * Business function
             */
            businessfunction?: string | null;
            /**
             * Manager user ID
             */
            managerid?: number;
            /**
             * Two-letter country code
             */
            country_code?: string;
            /**
             * Street address
             */
            address?: string;
            /**
             * City name
             */
            city?: string;
            /**
             * State or province
             */
            state?: string | null;
            /**
             * Postal or ZIP code
             */
            postal_code?: string | null;
            /**
             * GPS coordinates
             */
            gpscoordinates?: string | null;
            /**
             * Creation timestamp
             */
            created?: string | null;
            /**
             * Last update timestamp
             */
            updated?: string | null;
        };
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v2/locations/{id}/address',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get location by company ID
     * @param id
     * @returns any Location retrieved successfully
     * @throws ApiError
     */
    public static getApiV2LocationsCompany(
        id: number,
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: {
            /**
             * Location ID
             */
            id?: number;
            /**
             * Corporate entity ID
             */
            cid?: number | null;
            /**
             * Business function
             */
            businessfunction?: string | null;
            /**
             * Manager user ID
             */
            managerid?: number;
            /**
             * Two-letter country code
             */
            country_code?: string;
            /**
             * Street address
             */
            address?: string;
            /**
             * City name
             */
            city?: string;
            /**
             * State or province
             */
            state?: string | null;
            /**
             * Postal or ZIP code
             */
            postal_code?: string | null;
            /**
             * GPS coordinates
             */
            gpscoordinates?: string | null;
            /**
             * Creation timestamp
             */
            created?: string | null;
            /**
             * Last update timestamp
             */
            updated?: string | null;
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/locations/company/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get locations by manager ID
     * @param managerId
     * @returns any Locations retrieved successfully
     * @throws ApiError
     */
    public static getApiV2LocationsManager(
        managerId: number,
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: Array<{
            /**
             * Location ID
             */
            id?: number;
            /**
             * Corporate entity ID
             */
            cid?: number | null;
            /**
             * Business function
             */
            businessfunction?: string | null;
            /**
             * Manager user ID
             */
            managerid?: number;
            /**
             * Two-letter country code
             */
            country_code?: string;
            /**
             * Street address
             */
            address?: string;
            /**
             * City name
             */
            city?: string;
            /**
             * State or province
             */
            state?: string | null;
            /**
             * Postal or ZIP code
             */
            postal_code?: string | null;
            /**
             * GPS coordinates
             */
            gpscoordinates?: string | null;
            /**
             * Creation timestamp
             */
            created?: string | null;
            /**
             * Last update timestamp
             */
            updated?: string | null;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/locations/manager/{managerId}',
            path: {
                'managerId': managerId,
            },
        });
    }
}
